import { BalanceRest } from "@/services/rest/balance.rest";
import { PaymentRest } from "@/services/rest/payment.rest";
import { ScheduleRest } from "@/services/rest/schedule.rest";
import { CoupomRest } from "@/services/rest/Coupom.rest";
import { ComputerRest } from "@/services/rest/computer.rest";
export class clientServices {
  constructor(
    private _balance = new BalanceRest(),
    private _payment = new PaymentRest(),
    private _schedule = new ScheduleRest(),
    private _coupom = new CoupomRest(),
    private _computer = new ComputerRest(),
  ) {}

  getScheduleUser() {
    return this._schedule.getScheduleByUser().then((response) => {
      return response;
    });
  }

  getScheduleUserById(id: any) {
    return this._schedule.getScheduleById(id).then((response) => {
      return response;
    });
  }

  createSchedule(data: any) {
    return this._schedule.createSchedule(data).then((response) => {
      return response;
    });
  }

  deleteSchedule(id: any) {
    return this._schedule.deleteSchedule(id);
  }

  getBalanceUser() {
    return this._balance.getBalanceByUser().then((response) => {
      return response;
    });
  }

  getTransactions(params: any) {
    return this._payment.getAllTransactions(params).then((response) => {
      return response;
    });
  }

  createPayment(amountCredit: number) {
    return this._payment.createPayment(amountCredit).then((response) => {
      return response;
    });
  }

  createPaymentCoupon(code: string) {
    return this._payment.createPaymentCoupon(code).then((response) => {
      return response;
    });
  }

  getCheckCoupon(code: any) {
    return this._coupom.getCheckCoupon(code).then((response) => {
      return response;
    });
  }

  getAvailableComputers(params: { startDate: string; endDate: string }) {
    return this._computer.getComputersAvailableList(params).then((response) => {
      return response;
    });
  }
}
